import React from "react";

import { color } from "minimum-ui/tokens";
import styled from "styled-components";

import Actions from "./Actions";
import Header from "./Header";
import Subheader from "./Subheader";

type CardExports = React.FC<CardProps> & {
  Header: typeof Header;
  Subheader: typeof Subheader;
  Actions: typeof Actions;
};

export interface CardProps {
  className?: string;
}

const Card: React.FC<CardProps> = ({ className, children }) => {
  return <CardWrapper className={className}>{children}</CardWrapper>;
};

const CardWrapper = styled.section`
  border: 1px solid ${color.border.default};
  border-radius: 12px;
  background: ${color.basic.white};
  padding-bottom: 24px;
`;

const Exports = Card as CardExports;
Exports.Header = Header;
Exports.Subheader = Subheader;
Exports.Actions = Actions;

export default Exports;
